import { render, staticRenderFns } from "./tastingDetail.vue?vue&type=template&id=5b2505a1&"
import script from "./tastingDetail.vue?vue&type=script&lang=js&"
export * from "./tastingDetail.vue?vue&type=script&lang=js&"
import style0 from "./tastingDetail.vue?vue&type=style&index=0&id=5b2505a1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports